export const AppBarHeight = 50;
export const appBarThemeDefinition = () => ({
    MuiAppBar: {
        styleOverrides: {
            root: {
                '& .MuiToolbar-root': {
                    minHeight: AppBarHeight,
                    position: 'relative',
                },
            },
        },
    },
});
//# sourceMappingURL=appBarThemeDefinition.js.map